export const messages = {
  en: {
    addInspectionPlan: {
      title: 'Add Plan',
      planName: 'Plan Name',
      inspectionRoute: 'Inspection Route',
      inspectionPeriod: 'Inspection Period',
      taskAdvance: 'Task Advance',
      minutesGenerate: 'minutes generate',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      startDate: 'Start Date',
      endDate: 'End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      signMethod: 'Sign Method',
      allowRecheck: 'Allow Recheck',
      selectStaff: 'Select Staff',
      save: 'Save',
      back: 'Back',
      required: 'Required',
      monthlyDaily: 'Month/Day',
      weekly: 'Weekly',
      notAllowed: 'Not Allowed',
      allowed: 'Allowed',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  },
  zh: {
    addInspectionPlan: {
      title: '添加计划',
      planName: '计划名称',
      inspectionRoute: '巡检路线',
      inspectionPeriod: '巡检周期',
      taskAdvance: '任务提前',
      minutesGenerate: '分钟生成',
      month: '月',
      day: '日',
      week: '周',
      startDate: '开始日期',
      endDate: '结束日期',
      startTime: '开始时间',
      endTime: '结束时间',
      signMethod: '签到方式',
      allowRecheck: '允许补检',
      selectStaff: '选择员工',
      save: '保存',
      back: '返回',
      required: '必填',
      monthlyDaily: '月/天',
      weekly: '按周',
      notAllowed: '不允许补检',
      allowed: '允许补检',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
sunday: '星期日'
    }
  },
  'zh-TW': {
    addInspectionPlan: {
      title: '添加計劃',
      planName: '計劃名稱',
      inspectionRoute: '巡檢路線',
      inspectionPeriod: '巡檢週期',
      taskAdvance: '任務提前',
      minutesGenerate: '分鐘生成',
      month: '月',
      day: '日',
      week: '週',
      startDate: '開始日期',
      endDate: '結束日期',
      startTime: '開始時間',
      endTime: '結束時間',
      signMethod: '簽到方式',
      allowRecheck: '允許補檢',
      selectStaff: '選擇員工',
      save: '保存',
      back: '返回',
      required: '必填',
      monthlyDaily: '月/天',
      weekly: '按週',
      notAllowed: '不允許補檢',
      allowed: '允許補檢',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日'
    }
  }
}